import Admin from "@system/config/admin";
import Base from "../Base";
import Api from "../APIHandler";
const API = new Api({});

class ReportsAPICall extends Base {

    getReportsList = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(Admin.REPORTS_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                if (resHer.data.data) {
                    res = resHer.data
                }
            }
        }).catch((err) => {
            res = {};
        });

        return res;
    };

    getExportReportList = async (params = {}) => {
        let data = null;
        let param = {}
        param.data = params
        param.data.responseType = "blob"
        await API.post(Admin.EXPORT_REPORT_LIST, param).then((resHer) => {
            data = resHer.data;
        });
        return data;
    }

    emailReportList = async (params = {}) => {
        let data = null;
        let param = {}
        param.data = params
        await API.post(Admin.EMAIL_REPORT_LIST, param).then((resHer) => {
            data = resHer.data;
        });
        return data;
    }
}

export default ReportsAPICall;